import { type LucideIcon } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

type KpiCardProps = {
  label: string;
  value: string;
  icon?: LucideIcon;
  hint?: string;
  loading?: boolean;
  trend?: "up" | "down" | "flat";
  className?: string;
};

const trendColors: Record<"up" | "down" | "flat", string> = {
  up: "text-success",
  down: "text-destructive",
  flat: "text-muted-foreground",
};

export function KpiCard({
  label,
  value,
  icon: Icon,
  hint,
  loading,
  trend,
  className,
}: KpiCardProps): JSX.Element {
  return (
    <Card className={cn("overflow-hidden", className)}>
      <CardContent className="flex flex-col gap-3 p-5">
        <div className="flex items-center justify-between">
          <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            {label}
          </span>
          {Icon ? <Icon className="h-4 w-4 text-muted-foreground" /> : null}
        </div>
        {loading ? (
          <Skeleton className="h-9 w-32" />
        ) : (
          <div className={cn("tabular text-3xl font-semibold text-foreground", trend && trendColors[trend])}>
            {value}
          </div>
        )}
        {hint ? <p className="text-xs text-muted-foreground">{hint}</p> : null}
      </CardContent>
    </Card>
  );
}
